export default "__VITE_ASSET__8d32dd17__"